import { Routes } from '@angular/router';
import { LayoutComponent } from './ui/layout/layout.component';
import { authGuard } from './utils/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
  },
  {
    pathMatch: 'full',
    path: 'login',
    loadComponent: () => import('./ui/login/login.component').then(m => m.LoginComponent),
  },
  {
    pathMatch: 'full',
    path: 'cloud-redirect/:cloud',
    loadComponent: () => import('./db-redirect/db-redirect.component').then(m => m.DbRedirectComponent),
    canActivate: [authGuard],
  },
  {
    pathMatch: 'full',
    path: 'cloud-connection-redirect/:cloud',
    loadComponent: () => import('./components/examMode/examMode-tabs/cloud/cloud-connection-redirect/cloud-connection-redirect.component').then(m => m.CloudRedirectComponent),
    canActivate: [authGuard],
  },
  {
    pathMatch: 'full',
    path: 'cloud-connection-logout',
    loadComponent: () => import('./components/examMode/examMode-tabs/cloud/cloud-connection-logout/cloud-connection-logout.component').then(m => m.CloudConnectionLogoutComponent),
    canActivate: [authGuard],
  },
  {
    pathMatch: 'full',
    path: 'cloud-logout/:cloud',
    loadComponent: () => import('./components/cloud-logout/cloud-logout.component').then(m => m.CloudLogoutComponent),
    canActivate: [authGuard],
  },
  {
    pathMatch: 'full',
    path: 'forgot-password',
    loadComponent: () => import('./ui/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent),
  },
  {
    pathMatch: 'full',
    path: 'resetdb',
    loadComponent: () => import('./ui/reset-db/reset-db.component').then(m => m.ResetDbComponent),
  }, 
  {
    pathMatch: 'full',
    path: 'dodp_callback',
    loadComponent: () => import('./components/dialogs/dodp-storage-dialog/dodp-callback/dodp-callback.component').then(m => m.DodpCallbackComponent),
    canActivate: [authGuard],
  },
  {
    pathMatch: 'full',
    path: 'sti-callback',
    loadComponent: () => import('./components/dialogs/sti-dialog/sti-callback.component').then(m => m.StiCallbackComponent),
    canActivate: [authGuard],
  }
];
